import * as Sentry from '@sentry/react'

function normalizeError(err) {
  if (err instanceof Error) return err
  const e = new Error(typeof err === 'string' ? err : JSON.stringify(err))
  e.__original = err
  return e
}

// logError and logWarn report to Sentry themselves. The tag lets beforeSend in
// sentry.js drop the copy that CaptureConsole makes of their console output.
function consoleOnly(method, ...args) {
  Sentry.withScope(scope => {
    scope.setTag('console_copy', true)
    // eslint-disable-next-line no-console
    console[method](...args)
  })
}

export function logError(err, context, extras) {
  const error = normalizeError(err)

  consoleOnly('error', context ? `[${context}]` : '[error]', error, extras || '')

  Sentry.captureException(error, scope => {
    if (context) scope.setTag('context', context)
    if (extras && typeof extras === 'object') scope.setExtras(extras)
    scope.setTag('source', 'custom')
    return scope
  })
}

export function logWarn(message, context, extras) {
  const msg = context ? `[${context}] ${message}` : String(message)
  consoleOnly('warn', msg, extras || '')
  Sentry.captureMessage(msg, {
    level: 'warning',
    tags: { context: context || undefined, source: 'custom' },
    extra: extras,
  })
}
